import { render } from "./WithdrawRecord.vue?vue&type=template&id=7dc3ffa8&scoped=true"
import script from "./WithdrawRecord.vue?vue&type=script&lang=js"
export * from "./WithdrawRecord.vue?vue&type=script&lang=js"

import "./WithdrawRecord.vue?vue&type=style&index=0&id=7dc3ffa8&lang=less&scoped=true"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc3ffa8"]])

export default __exports__